export { default } from './AnimatedBox';
export * from './types';
